import { getPieRadius } from '../../utils/chart'; // 小型环形的外半径与环形的内半径的比例

var smallRingRatio = 3.33; // 小型环形的阴影环形外半径与环形的内半径的比例

var smallRingShadowRatio = 1.4;
export default function (chart, ringSeries) {
  var radius = getPieRadius(chart.radius);
  var insideRadius = radius.outside / smallRingRatio; // set inside radius

  chart.radius[0] = insideRadius + "%";
  ringSeries.push({
    type: 'pie',
    color: 'rgba(0, 0, 0, 0.2)',
    data: [{
      value: 1
    }],
    silent: true,
    labelLine: {
      normal: {
        show: false
      }
    },
    radius: [insideRadius + "%", insideRadius * smallRingShadowRatio + "%"],
    center: chart.center,
    z: 3
  });
}